module.exports = __webpack_public_path__ + "static/media/torii-gate.bfdb0ca8.svg";